/* eslint-disable no-unused-expressions */
/* eslint-disable import/extensions */
/* eslint-disable react/forbid-prop-types */

import React from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { StyledDialog, Content } from './styles';

// Modal de Login por link de email
const VideoModal = ({ open, onClose }) => (
  <StyledDialog
    open={open}
    onClose={onClose}
  >
    <Content>
      <IconButton
        color="secondary"
        onClick={onClose}
      >
        Fechar
        <CloseIcon />
      </IconButton>
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/StGqxw6xlpw"
        title="Revisão do FGTS - saiba como seu dinheiro pode aumentar com a correção monetária atualizada."
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </Content>
  </StyledDialog>
);

VideoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default VideoModal;
